import React from 'react'
import { SvgIcon } from '@mui/material'

export function RefreshIcon() {
  return (
    <SvgIcon
      viewBox="0 0 64 64"
      sx={{ color: 'error.main', width: '64px', height: '64px' }}
    >
      <g clipPath="url(#RefreshIcon)">
        <path
          fill="#55A6FF"
          d="m49.733 22.267-7.44 7.44c-.853.853-.266 2.293.934 2.293H48c0 8.827-7.173 16-16 16-2.107 0-4.16-.4-6-1.173-.96-.4-2.053-.107-2.773.613-1.36 1.36-.88 3.653.906 4.373A20.876 20.876 0 0 0 32 53.333c11.787 0 21.333-9.547 21.333-21.333h4.774c1.2 0 1.786-1.44.933-2.267l-7.44-7.44a1.312 1.312 0 0 0-1.867-.026ZM16 32c0-8.827 7.173-16 16-16 2.107 0 4.16.4 6 1.173.96.4 2.053.107 2.773-.613 1.36-1.36.88-3.653-.906-4.373A20.874 20.874 0 0 0 32 10.667c-11.787 0-21.333 9.546-21.333 21.333H5.893c-1.2 0-1.786 1.44-.933 2.267l7.44 7.44a1.32 1.32 0 0 0 1.893 0l7.44-7.44c.827-.827.24-2.267-.96-2.267H16Z"
        />
      </g>
      <defs>
        <clipPath id="RefreshIcon">
          <path fill="#fff" d="M0 0h64v64H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
